module.exports = __webpack_public_path__ + "img/o10.f984302b.png";